"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _statementExportApi = require("@/api/statementExportApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StatementListExportRecordDialog',
  data: function data() {
    return {
      visible: false,
      loading: false,
      list: [],
      query: {
        taskName: '',
        status: ''
      },
      createTimeRange: [],
      pagination: {
        page: 1,
        limit: 20,
        total: 0,
        totalPage: 0
      },
      actionLoadingMap: {},
      statusOptions: [{
        label: '等待处理',
        value: 'PENDING'
      }, {
        label: '排队中',
        value: 'WAITING'
      }, {
        label: '正在导出',
        value: 'PROCESSING'
      }, {
        label: '导出完成',
        value: 'COMPLETED'
      }, {
        label: '导出失败',
        value: 'FAILED'
      }, {
        label: '已中止',
        value: 'CANCELLED'
      }]
    };
  },
  methods: {
    open: function open() {
      this.visible = true;
      this.pagination.page = 1;
      this.fetchList();
    },
    fetchList: function () {
      var _fetchList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.loading) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.loading = true;
              _context.p = 2;
              _context.n = 3;
              return (0, _statementExportApi.getStatementListExportTaskList)(this.buildQueryParams());
            case 3:
              data = _context.v;
              this.list = data && data.list || [];
              this.pagination = {
                page: data && data.page || this.pagination.page,
                limit: data && data.limit || this.pagination.limit,
                total: data && data.total || 0,
                totalPage: data && data.totalPage || 0
              };
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.list = [];
            case 5:
              _context.p = 5;
              this.loading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function fetchList() {
        return _fetchList.apply(this, arguments);
      }
      return fetchList;
    }(),
    buildQueryParams: function buildQueryParams() {
      var params = {
        page: this.pagination.page,
        limit: this.pagination.limit,
        status: this.query.status,
        taskName: this.query.taskName
      };
      if (Array.isArray(this.createTimeRange) && this.createTimeRange.length === 2) {
        params.startTime = this.createTimeRange[0];
        params.endTime = this.createTimeRange[1];
      }
      Object.keys(params).forEach(function (key) {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      return params;
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.query = {
        taskName: '',
        status: ''
      };
      this.createTimeRange = [];
      this.pagination.page = 1;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(limit) {
      this.pagination.limit = limit;
      this.pagination.page = 1;
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      this.fetchList();
    },
    getProgress: function getProgress(row) {
      if (row.status === 'COMPLETED') return 100;
      var progress = Number(row.progress);
      if (Number.isNaN(progress)) return 0;
      return Math.min(100, Math.max(0, Math.round(progress)));
    },
    statusText: function statusText(status) {
      var option = this.statusOptions.find(function (item) {
        return item.value === status;
      });
      return option ? option.label : status || '-';
    },
    statusTagType: function statusTagType(status) {
      var map = {
        PENDING: 'info',
        WAITING: 'warning',
        PROCESSING: 'primary',
        COMPLETED: 'success',
        FAILED: 'danger',
        CANCELLED: 'warning'
      };
      return map[status] || 'info';
    },
    downloadFile: function downloadFile(row) {
      if (!row.downloadUrl) {
        this.$message.error('文件下载地址不存在');
        return;
      }
      this.$download.url(row.downloadUrl, row.fileName);
    },
    handleCancel: function handleCancel(row) {
      this.confirmAction(row, '确定取消该排队任务吗？', _statementExportApi.cancelStatementListExportTask, '排队任务已取消');
    },
    handleStop: function handleStop(row) {
      this.confirmAction(row, '确定中止当前导出任务吗？', _statementExportApi.stopStatementListExportTask, '已发出中止指令');
    },
    confirmAction: function confirmAction(row, message, action, successMessage) {
      var _this = this;
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var taskId, task, index, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _this.$set(_this.actionLoadingMap, row.id || row.taskId, true);
              _context2.p = 1;
              _context2.n = 2;
              return action(row.id || row.taskId);
            case 2:
              _this.$message.success(successMessage);
              taskId = row.id || row.taskId;
              _context2.p = 3;
              _context2.n = 4;
              return (0, _statementExportApi.getStatementListExportTaskDetail)(taskId);
            case 4:
              task = _context2.v;
              index = _this.list.findIndex(function (item) {
                return (item.id || item.taskId) === taskId;
              });
              if (index !== -1) {
                _this.$set(_this.list, index, _objectSpread(_objectSpread({}, _this.list[index]), task || {}));
              }
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              _this.$message.warning('操作成功，但刷新任务状态失败，请手动刷新');
            case 6:
              _context2.p = 6;
              _this.$delete(_this.actionLoadingMap, row.id || row.taskId);
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, null, [[3, 5], [1,, 6, 7]]);
      }))).catch(function () {});
    },
    isActionLoading: function isActionLoading(row) {
      return Boolean(this.actionLoadingMap[row.id || row.taskId]);
    }
  }
};